export default "__VITE_ASSET__3c5c6d8f__"